import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { CheckCircle, ArrowLeft } from 'lucide-react';
import { translations } from '../data/mock';

const MessageReceived = () => {
  const navigate = useNavigate();
  const [currentLang, setCurrentLang] = useState('en');

  useEffect(() => {
    // Detect language from localStorage or browser
    const savedLang = localStorage.getItem('biteSiteLang');
    if (savedLang) {
      setCurrentLang(savedLang);
    } else {
      const browserLang = navigator.language || navigator.userLanguage;
      if (browserLang.startsWith('fr')) {
        setCurrentLang('fr');
      }
    }
  }, []);

  const t = translations[currentLang].messageReceived;

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-6">
      <div className="max-w-2xl w-full text-center">
        {/* Checkmark Icon */}
        <div className="flex justify-center mb-8">
          <div className="w-24 h-24 bg-green-500/20 rounded-full flex items-center justify-center">
            <CheckCircle className="w-16 h-16 text-green-500" strokeWidth={2} />
          </div>
        </div>

        {/* Heading */}
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
          {t.title}
        </h1>

        {/* Subtext */}
        <p className="text-xl md:text-2xl text-slate-400 mb-12 leading-relaxed max-w-xl mx-auto">
          {t.subtitle}
        </p>

        {/* Back to Home Button */}
        <Button
          onClick={() => navigate('/')}
          size="lg"
          className="bg-white text-slate-900 hover:bg-slate-100 text-lg px-8 py-6 rounded-lg transition-all duration-200 hover:scale-105 hover:shadow-xl"
        >
          <ArrowLeft className="mr-2 h-5 w-5" />
          {t.buttonText}
        </Button>

        {/* Additional Info */}
        <div className="mt-12 pt-8 border-t border-slate-800">
          <p className="text-slate-500 text-sm">
            {t.needHelp}{' '}
            <a 
              href="mailto:ErikmAndersen@proton.me" 
              className="text-white hover:underline"
            >
              {t.emailUs}
            </a>
            {' '}{t.orCall}{' '}
            <a 
              href="tel:+41798121911" 
              className="text-white hover:underline"
            >
              +41 79 812 19 11
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default MessageReceived;
